import Vue from 'vue'
import SvgIcon from '@/components/SvgIcon'

Vue.component('SvgIcon', SvgIcon)

const svgRequire = require.context('./', false, /\.svg$/)
svgRequire.keys().forEach( svgIcon=>svgRequire(svgIcon))